document.addEventListener("DOMContentLoaded", () => {
  const traducaoStatus = {
    deliveryStatus: {
      null: "Aguardando envio",
      in_transit: "Em trânsito",
      delivered: "Entregue",
      cancelled: "Cancelado",
      fulfilled: "Enviado",
      DELIVERED: "Entregue",
      IN_TRANSIT: "Em trânsito",
      SHIPPED: "Despachado",
      NEW: "Criado",
      READY_FOR_SHIPPING: "Pronto para envio",
      TO_BE_DELIVERED: "Saiu para entrega"
    },
    paymentStatus: {
      paid: "Pago",
      pending: "Pendente",
      refunded: "Reembolsado",
      failed: "Falhou",
    },
  }

  //  FUNÇÃO PARA CALCULAR PROGRESSO DA BARRA
  function calcularProgresso(statusEntrega) {
    switch (statusEntrega) {
      case null:
      case "pending":
      case "NEW":
        return 33 // Confirmado
      case "in_transit":
      case "fulfilled":
      case "IN_TRANSIT":
      case "SHIPPED":
      case "READY_FOR_SHIPPING":
      case "TO_BE_DELIVERED":
      case "to_be_delivered":
        return 66 // Em Trânsito
      case "delivered":
      case "DELIVERED":
        return 100 // Entregue
      case "cancelled":
        return 0 // Cancelado
      default:
        return 33 // Padrão
    }
  }

  //  FUNÇÃO PARA DEFINIR COR DA BARRA
  function corProgresso(statusEntrega) {
    switch (statusEntrega) {
      case "delivered":
        return "linear-gradient(90deg, #4caf50, #2e7d32)" // Verde para entregue
      case "DELIVERED":
        return "linear-gradient(90deg, #4caf50, #2e7d32)" // Verde para entregue
      case "cancelled":
        return "linear-gradient(90deg, #f44336, #c62828)" // Vermelho para cancelado
      case "in_transit":
      case "fulfilled":
      case "IN_TRANSIT":
      case "SHIPPED":
      case "READY_FOR_SHIPPING":
        return "linear-gradient(90deg, #ff9800, #f57c00)" // Laranja para em trânsito
      default:
        return "linear-gradient(90deg, #6734ff, #4812e7)" // Roxo padrão
    }
  }

  const failCarriers = ["Bristot", "Figueiredo", "Binho", "Tenha", "Translovato", "Minuano", "Dialogo"]

  const dataEstimadaEntrega = "Indisponível"

  const btnAvaliar = document.createElement("a")
  btnAvaliar.className = "evaluateOrder"
  btnAvaliar.target = "_blank"
  btnAvaliar.innerHTML = `<svg fill="#ffffff" width="24px" height="24px" viewBox="0 0 24 24" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><title></title><path d="M12,2a8,8,0,0,0-8,8c0,5.4,7,11.5,7.35,11.76l.65.56.65-.56C13,21.5,20,15.4,20,10A8,8,0,0,0,12,2Zm0,12a4,4,0,1,1,4-4A4,4,0,0,1,12,14Z"></path><circle cx="12" cy="10" r="2"></circle></g></svg> Rastrear pedido`

  const btnComprovante = document.createElement("a")
  btnComprovante.className = "shippingComprovate"
  btnComprovante.target = "_blank"
  btnComprovante.innerHTML = `<svg fill="#fff" width="22px" height="22px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M 0 6 L 0 8 L 19 8 L 19 23 L 12.84375 23 C 12.398438 21.28125 10.851563 20 9 20 C 7.148438 20 5.601563 21.28125 5.15625 23 L 4 23 L 4 18 L 2 18 L 2 25 L 5.15625 25 C 5.601563 26.71875 7.148438 28 9 28 C 10.851563 28 12.398438 26.71875 12.84375 25 L 21.15625 25 C 21.601563 26.71875 23.148438 28 25 28 C 26.851563 28 28.398438 26.71875 28.84375 25 L 32 25 L 32 16.84375 L 31.9375 16.6875 L 29.9375 10.6875 L 29.71875 10 L 21 10 L 21 6 Z M 1 10 L 1 12 L 10 12 L 10 10 Z M 21 12 L 28.28125 12 L 30 17.125 L 30 23 L 28.84375 23 C 28.398438 21.28125 26.851563 20 25 20 C 23.148438 20 21.601563 21.28125 21.15625 23 L 21 23 Z M 2 14 L 2 16 L 8 16 L 8 14 Z M 9 22 C 10.117188 22 11 22.882813 11 24 C 11 25.117188 10.117188 26 9 26 C 7.882813 26 7 25.117188 7 24 C 7 22.882813 7.882813 22 9 22 Z M 25 22 C 26.117188 22 27 22.882813 27 24 C 27 25.117188 26.117188 26 25 26 C 23.882813 26 23 25.117188 23 24 C 23 22.882813 23.882813 22 25 22 Z"></path></g></svg> Comprovante de Entrega`

  async function buscarRastreamentoIntelipost(idPedido) {
    try {
      const res = await fetch(`https://backend-painel-do-cliente.onrender.com/intelipost/${idPedido}`)
      const json = await res.json()
      const data = json.content

      if (!json.status === "OK") {
        throw new Error("Requisição inválida a intelipost")
      }

      const dataISO = data.estimated_delivery_date_iso // Data em formato ISO 8601

      // Criando um objeto Date a partir da data ISO
      const dataReal = new Date(dataISO)

      const strongEntrega = document.querySelector("strong.deliveryForecast")

      if (strongEntrega) strongEntrega.innerText = dataReal.toLocaleDateString("pt-BR")

      //  ATUALIZAÇÃO DO STATUS VIA API INTELIPOST (sua mudança mantida!)
      const strongStatusEntrega = document.querySelector("strong.statusOrder.statusComp")
      if (strongStatusEntrega)
        strongStatusEntrega.innerText = ` ${traducaoStatus.deliveryStatus[data.shipment_order_volume_state]}`

      //  ATUALIZAR BARRA DE PROGRESSO COM STATUS DA API
      const progressoAtual = calcularProgresso(data.shipment_order_volume_state)
      const corBarra = corProgresso(data.shipment_order_volume_state)
      const progressFill = document.querySelector(".progress-fill-compact")
      const progressLabels = document.querySelectorAll(".progress-labels-compact span")

      if (progressFill) {
        progressFill.style.width = `${progressoAtual}%`
        progressFill.style.background = corBarra
      }

      // Atualizar labels ativas
      if (progressLabels.length > 0) {
        progressLabels.forEach((label, index) => {
          if ((index + 1) * 33 <= progressoAtual) {
            label.classList.add("active")
          } else {
            label.classList.remove("active")
          }
        })
      }
        let existsDelivered;
        console.log(data.shipment_order_volume_array[0].shipment_order_volume_state_history_array);
        const orderDelivered = data.shipment_order_volume_array[0].shipment_order_volume_state_history_array.forEach((order)=>{
            console.log(order.shipment_order_volume_state);
            if(order.shipment_order_volume_state == "DELIVERED") {
              existsDelivered = order;
            }
        })

        console.log(existsDelivered);
      
      if (!existsDelivered) {
        btnComprovante.classList.add("disabledLinkBtn")
        btnComprovante.removeAttribute("href")
      }
      btnAvaliar.href = data.tracking_url
      btnComprovante.href = existsDelivered.attachments[0].url;
    } catch (error) {
      console.error("Erro ao buscar rastreamento:", error)
      btnAvaliar.classList.add("disabledLinkBtn")
      btnAvaliar.innerHTML = `<svg fill="#ffffff" width="24px" height="24px" viewBox="0 0 24 24" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><title></title><path d="M12,2a8,8,0,0,0-8,8c0,5.4,7,11.5,7.35,11.76l.65.56.65-.56C13,21.5,20,15.4,20,10A8,8,0,0,0,12,2Zm0,12a4,4,0,1,1,4-4A4,4,0,0,1,12,14Z"></path><circle cx="12" cy="10" r="2"></circle></g></svg> Rastreio indisponível`
      btnComprovante.classList.add("disabledLinkBtn")
      btnComprovante.innerHTML = `<svg fill="#fff" width="22px" height="22px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M 0 6 L 0 8 L 19 8 L 19 23 L 12.84375 23 C 12.398438 21.28125 10.851563 20 9 20 C 7.148438 20 5.601563 21.28125 5.15625 23 L 4 23 L 4 18 L 2 18 L 2 25 L 5.15625 25 C 5.601563 26.71875 7.148438 28 9 28 C 10.851563 28 12.398438 26.71875 12.84375 25 L 21.15625 25 C 21.601563 26.71875 23.148438 28 25 28 C 26.851563 28 28.398438 26.71875 28.84375 25 L 32 25 L 32 16.84375 L 31.9375 16.6875 L 29.9375 10.6875 L 29.71875 10 L 21 10 L 21 6 Z M 1 10 L 1 12 L 10 12 L 10 10 Z M 21 12 L 28.28125 12 L 30 17.125 L 30 23 L 28.84375 23 C 28.398438 21.28125 26.851563 20 25 20 C 23.148438 20 21.601563 21.28125 21.15625 23 L 21 23 Z M 2 14 L 2 16 L 8 16 L 8 14 Z M 9 22 C 10.117188 22 11 22.882813 11 24 C 11 25.117188 10.117188 26 9 26 C 7.882813 26 7 25.117188 7 24 C 7 22.882813 7.882813 22 9 22 Z M 25 22 C 26.117188 22 27 22.882813 27 24 C 27 25.117188 26.117188 26 25 26 C 23.882813 26 23 25.117188 23 24 C 23 22.882813 23.882813 22 25 22 Z"></path></g></svg> Comprovante Indisponível`

      throw error
    }
  }

  const orderNumberElement = document.querySelector(".account-header.account-header--back h1")
  let numeroPedido = null
  const numeroLoja = "204310575" // Número fixo da loja (caso não seja variável)
  let idPedido = null

  // Spinner
  const spinner = document.createElement("div")
  spinner.id = "loadingSpinner"
  spinner.innerHTML = `
    <div style="
      position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
      background: rgba(255,255,255,0.8); display: flex;
      align-items: center; justify-content: center; z-index: 10000;">
      <div style="
        width: 48px; height: 48px;
        border: 5px solid #ccc;
        border-top: 5px solid #6734ff;
        border-radius: 50%;
        animation: spin 1s linear infinite;"></div>
      <style>@keyframes spin {to {transform: rotate(360deg);}}</style>
    </div>`
  document.body.appendChild(spinner)

  // Captura número do pedido
  if (orderNumberElement) {
    const pedido = orderNumberElement.innerText || orderNumberElement.textContent
    numeroPedido = pedido.split(" ")[1].replace("#", "").trim()
  }

  if (!numeroPedido) {
    console.error("Número do pedido não encontrado na página.")
    spinner.remove()
    return
  }
  const pedidoName = encodeURIComponent(`#${numeroPedido}`)
  console.log(pedidoName)

  fetch(`https://backend-painel-do-cliente.onrender.com/pedidos/${pedidoName}`)
    .then((res) => res.json())
    .then((pedido) => {
      console.log(pedido)
      if (pedido.erro) {
        console.error(pedido.erro)
        spinner.remove()
        return
      }
      idPedido = pedido.id
      buscarRastreamentoIntelipost(idPedido)
      renderPedido(pedido, numeroPedido)
      spinner.remove()
    })
    .catch((err) => {
      console.error(err)
      spinner.remove()
    })

  function renderPedido(pedido, numeroPedido) {
    const orderDiv = document.querySelector(".order")
    const addresses = document.querySelector(".order-addresses-list")
    if (addresses) addresses.remove()

    const container = document.createElement("div")
    container.classList.add("order-addresses-list")

    //  NOVA FUNCIONALIDADE 
    const items = document.querySelectorAll("line-item")
    items.forEach((item) => {
      const linkProduto = item.querySelector("a.bold")?.getAttribute("href")

      if (!linkProduto) return

      // Remove info_parcelar e texto secundário
      const infoParcelar = item.querySelector(".info_parcelar")
      if (infoParcelar) infoParcelar.remove()

      const descricaoSecundaria = item.querySelector("p.text-sm.text-subdued")
      if (descricaoSecundaria) descricaoSecundaria.remove()

      // Cria botão Avaliar Produto
      const btn = document.createElement("a")
      btn.href = `${linkProduto}#reviews`
      btn.classList.add("reviewsBtn")
      btn.target = "_blank"
      btn.innerHTML =
        '<svg fill="#ffffff" width="17px" height="17px" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M1915.918 737.475c-10.955-33.543-42.014-56.131-77.364-56.131h-612.029l-189.063-582.1v-.112C1026.394 65.588 995.335 43 959.984 43c-35.237 0-66.41 22.588-77.365 56.245L693.443 681.344H81.415c-35.35 0-66.41 22.588-77.365 56.131-10.955 33.544.79 70.137 29.478 91.03l495.247 359.831-189.177 582.212c-10.955 33.657 1.13 70.25 29.817 90.918 14.23 10.278 30.946 15.487 47.66 15.487 16.716 0 33.432-5.21 47.775-15.6l495.134-359.718 495.021 359.718c28.574 20.781 67.087 20.781 95.662.113 28.687-20.668 40.658-57.261 29.703-91.03l-189.176-582.1 495.36-359.83c28.574-20.894 40.433-57.487 29.364-91.03" fill-rule="evenodd"></path> </g></svg> <span class="textReviews">Verificar Avaliações<span>'
      btn.style = `
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        background-color: #6734ff;
        color: white;
        padding: 8px 16px;
        border-radius: 5px;
        text-decoration: none;
        font-weight: 600;
        font-size: 14px;
        margin-top: 6px;
      `

      btn.addEventListener("mouseenter", () => {
        btn.style.backgroundColor = "#5223de"
      })
      btn.addEventListener("mouseleave", () => {
        btn.style.backgroundColor = "#6734ff"
      })

      const infoDiv = item.querySelector(".line-item__info")
      if (infoDiv) {
        infoDiv.appendChild(btn)
      }
    })

    // Bloco pagamento
    const pagamento = document.createElement("div")
    pagamento.className = "address gap-4 rounded-sm"
    pagamento.innerHTML = `
      <div class="text-with-icon">
        <svg width="27px" height="27px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M19 6.34267C17.35 4.30367 14.8273 3 12 3C7.02944 3 3 7.02944 3 12C3 13.8501 3.55827 15.5699 4.51555 17M21 12C21 16.9706 16.9706 21 12 21C10.961 21 9.96308 20.8239 9.03452 20.5M12 16H13C13.6667 16 15 15.6 15 14C15 12.4 13.6667 12 13 12H11C10.3333 12 9 11.6 9 10C9 8.4 10.3333 8 11 8H12M12 16H9M12 16V18M15 8H12M12 8V6" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg> <p class="bold">Pagamento</p>
      </div>
      <p><strong>Pagamento via:</strong> ${pedido.pagamento}</p>
      <p><span class="midInfo">Total produtos: <strong>R$ ${Number(pedido.total_produtos).toFixed(2)}</strong></span></p>
      <p><span class="midInfo">Frete: <strong>R$ ${Number(pedido.frete.valor).toFixed(2)}</strong></span></p>
      <p><span class="midInfo">Desconto: <strong>-R$ ${Number(pedido.desconto).toFixed(2)}</strong></span></p>
      <p><span class="midInfo">Taxas: <strong>R$ ${Number(pedido.total_tax || 0).toFixed(2)}</strong></span></p>
      <p><span class="midInfo mainInfo">Total do pedido: <strong>R$ ${Number(pedido.total_pedido).toFixed(2)}</strong></span></p>
    `

    // Bloco entrega
    const entrega = document.createElement("div")
    entrega.className = "address gap-4 rounded-sm"
    entrega.innerHTML = `
      <div class="text-with-icon">
        <svg fill="#000000" height="20px" width="20px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 256 256" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <polygon points="256,80.7 211.6,36.9 142,36.9 142,80.7 "></polygon> <polygon points="118,36.9 48.1,36.9 4,80.7 118,80.7 "></polygon> <path d="M142,93.9v44.4H118V93.9H4v169.2h252V93.9H142z M176.1,180.1l16.6,16.6h-7.2V225h-18.9v-28.3h-7.2L176.1,180.1z M238.8,245.9h-79.3V233h79.3V245.9z M231.7,196.7V225h-18.9v-28.3h-7.2l16.6-16.6l16.6,16.6H231.7z"></path> </g></svg> <p class="bold">Entrega</p>
      </div>
      <p><strong>${pedido.cliente}</strong></p>
      <p>${pedido.endereco.rua} ${pedido.endereco.numero}</p>
      <p>${pedido.endereco.complemento || "Complemento não informado"}, ${pedido.endereco.bairro}</p>
      <p>${pedido.endereco.cidade_estado_pais}</p>
      <p>${pedido.endereco.cep}</p>
    `

    const btnNotaFiscal = document.createElement("a")
    btnNotaFiscal.className = "invoiceButton"
    btnNotaFiscal.href = "javascript:void(0);"
    btnNotaFiscal.id = "emitirNotaFiscal"
    btnNotaFiscal.innerHTML = `<svg width="17px" height="17px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="#000000" stroke="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>note-text</title> <desc>Created with Sketch Beta.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"> <g id="Icon-Set-Filled" sketch:type="MSLayerGroup" transform="translate(-310.000000, -101.000000)" fill="#ffffff"> <path d="M334,111 L318,111 C317.447,111 317,110.553 317,110 C317,109.448 317.447,109 318,109 L334,109 C334.553,109 335,109.448 335,110 C335,110.553 334.553,111 334,111 L334,111 Z M334,117 L318,117 C317.447,117 317,116.553 317,116 C317,115.448 317.447,115 318,115 L334,115 C334.553,115 335,115.448 335,116 C335,116.553 334.553,117 334,117 L334,117 Z M334,123 L318,123 C317.447,123 317,122.553 317,122 C317,121.448 317.447,121 318,121 L334,121 C334.553,121 335,121.448 335,122 C335,122.553 334.553,123 334,123 L334,123 Z M338,101 L314,101 C311.806,101 310,102.969 310,105.165 L310,129.023 C310,131.22 311.779,133 313.974,133 L337.817,133 C340.012,133 342,131.196 342,129 L342,105 C342,102.804 340.194,101 338,101 L338,101 Z" id="note-text" sketch:type="MSShapeGroup"> </path> </g> </g> </g></svg> Nota Fiscal`

    entrega.appendChild(btnComprovante)
    entrega.appendChild(btnNotaFiscal)

    //  CALCULANDO PROGRESSO DINÂMICO
    const progressoAtual = calcularProgresso(pedido.status_entrega)
    const corBarra = corProgresso(pedido.status_entrega)

    //  VERIFICAR SE OS STATUS SÃO DE SUCESSO
    const entregaSuccess = ["delivered", "DELIVERED", "Entregue", "fulfilled", "FULFILLED"].includes(pedido.status_entrega);
    const pagamentoSuccess = pedido.status_pagamento === "paid"

    //  BLOCO STATUS COMPACTO COM BARRA DINÂMICA - DESIGN BONITINHO!
    const status = document.createElement("div")
    status.className = "address gap-4 rounded-sm"
    status.innerHTML = `
<div class="text-with-icon">
  <svg width="26px" height="26px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="Edit / Sort_Ascending"> <path id="Vector" d="M4 17H10M4 12H13M18 11V19M18 19L21 16M18 19L15 16M4 7H16" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g> </g></svg> <p class="bold">Status Pedido</p>
</div>

<!-- Status Compacto -->
<div class="status-compact-item ${entregaSuccess ? "success" : ""}">
  <div class="status-info">
    <svg class="status-icon-small" fill="${entregaSuccess ? "#4caf50" : "#ff8c00"}" width="16px" height="16px" viewBox="0 0 24 24"><path d="M19 7h-3V6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v11a3 3 0 0 0 3 3h1.05A3 3 0 0 0 11 18h2a3 3 0 0 0 2.95 2H17a3 3 0 0 0 3-3v-7a1 1 0 0 0-1-1zM7 18.05A1 1 0 0 1 6 17V7h8v3h-4a1 1 0 0 0-1 1v7.05zM18 17a1 1 0 0 1-1.95.05V12H18z"/></svg>
    <span class="status-label">Entrega</span>
  </div>
  <strong class="status-badge-compact ${entregaSuccess ? "status-success" : "status-delivery"} statusOrder statusComp">Entrega: ${pedido.status_entrega ? traducaoStatus.deliveryStatus.null : traducaoStatus.deliveryStatus[pedido.status_entrega]}</strong>
</div>

<div class="status-compact-item ${pagamentoSuccess ? "success" : ""}">
  <div class="status-info">
    <svg class="status-icon-small" fill="${pagamentoSuccess ? "#4caf50" : "#ffd700"}" width="16px" height="16px" viewBox="0 0 24 24"><path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM4 6h16v2H4zm0 4h16v8H4z"/><path d="M6 14h2v2H6zm4 0h8v2h-8z"/></svg>
    <span class="status-label">Pagamento</span>
  </div>
  <strong class="status-badge-compact ${pagamentoSuccess ? "status-success" : "status-payment"} statusPayment statusComp">${traducaoStatus.paymentStatus[pedido.status_pagamento]}</strong>
</div>

<div class="status-compact-item">
  <div class="status-info">
    <svg class="status-icon-small" fill="#888" width="16px" height="16px" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/><path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"/></svg>
    <span class="status-label">Previsão de Entrega</span>
  </div>
  <strong class="status-badge-compact status-forecast deliveryForecast statusComp">${dataEstimadaEntrega}</strong>
</div>

<!-- Barra de Progresso DINÂMICA -->
<div class="progress-compact">
  <div class="progress-labels-compact">
    <span class="${progressoAtual >= 33 ? "active" : ""}">Confirmado</span>
    <span class="${progressoAtual >= 66 ? "active" : ""}">Em Trânsito</span>
    <span class="${progressoAtual >= 100 ? "active" : ""}">Entregue</span>
  </div>
  <div class="progress-bar-compact">
    <div class="progress-fill-compact" style="width: ${progressoAtual}%; background: ${corBarra};"></div>
  </div>
</div>
`

    const btnAjuda = document.createElement("a")
    btnAjuda.className = "canHelpU"
    btnAjuda.href = "https://api.whatsapp.com/send?l=pt&phone=5548999429288&text=Ol%C3%A1!%20Vim%20do%20site%20e%20preciso%20de%20ajuda."
    btnAjuda.target = "_blank"
    btnAjuda.innerHTML = `<svg width="26px" height="26px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zM7.92 9.234v.102a.5.5 0 0 0 .5.5h.997a.499.499 0 0 0 .499-.499c0-1.29.998-1.979 2.34-1.979 1.308 0 2.168.689 2.168 1.67 0 .928-.482 1.359-1.686 1.91l-.344.154C11.379 11.54 11 12.21 11 13.381v.119a.5.5 0 0 0 .5.5h.997a.499.499 0 0 0 .499-.499c0-.516.138-.723.55-.912l.345-.155c1.445-.654 2.529-1.514 2.529-3.39v-.103c0-1.978-1.72-3.441-4.164-3.441-2.478 0-4.336 1.428-4.336 3.734zm2.58 7.757c0 .867.659 1.509 1.491 1.509.85 0 1.509-.642 1.509-1.509 0-.867-.659-1.491-1.509-1.491-.832 0-1.491.624-1.491 1.491z" fill="#000000"></path></g></svg> Preciso de ajuda`

    status.appendChild(btnAvaliar)
    status.appendChild(btnAjuda)

    container.append(pagamento, entrega, status)
    orderDiv.appendChild(container)

    // Função para gerar nota fiscal a partir do id da nota
    async function gerarNotaFiscal(idDaNota) {
      try {
        const response = await fetch(`https://backend-painel-do-cliente.onrender.com/nfe/${idDaNota}`)
        if (!response.ok) throw new Error("Erro ao buscar nota fiscal")
        const dadosNota = await response.json()

        console.log(dadosNota)

        return dadosNota // ou o que precisar retornar
      } catch (error) {
        console.error("Erro em gerarNotaFiscal:", error)
        btnNotaFiscal.classList.add("disabledLinkBtn")
        btnNotaFiscal.innerHTML = `<svg width="17px" height="17px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="#000000" stroke="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>note-text</title> <desc>Created with Sketch Beta.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"> <g id="Icon-Set-Filled" sketch:type="MSLayerGroup" transform="translate(-310.000000, -101.000000)" fill="#ffffff"> <path d="M334,111 L318,111 C317.447,111 317,110.553 317,110 C317,109.448 317.447,109 318,109 L334,109 C334.553,109 335,109.448 335,110 C335,110.553 334.553,111 334,111 L334,111 Z M334,117 L318,117 C317.447,117 317,116.553 317,116 C317,115.448 317.447,115 318,115 L334,115 C334.553,115 335,115.448 335,116 C335,116.553 334.553,117 334,117 L334,117 Z M334,123 L318,123 C317.447,123 317,122.553 317,122 C317,121.448 317.447,121 318,121 L334,121 C334.553,121 335,121.448 335,122 C335,122.553 334.553,123 334,123 L334,123 Z M338,101 L314,101 C311.806,101 310,102.969 310,105.165 L310,129.023 C310,131.22 311.779,133 313.974,133 L337.817,133 C340.012,133 342,131.196 342,129 L342,105 C342,102.804 340.194,101 338,101 L338,101 Z" id="note-text" sketch:type="MSShapeGroup"> </path> </g> </g> </g></svg> Nota fiscal disponível em breve`
      }
    }

    // Evento botão nota fiscal
    btnNotaFiscal.addEventListener("click", async () => {
      console.log(idPedido)
      try {
        const res = await fetch(`https://backend-painel-do-cliente.onrender.com/pedidos/vendas/${idPedido}`)
        if (!res.ok) throw new Error("Erro ao buscar pedido")
        const data = await res.json()

        const downloadOptions = await gerarNotaFiscal(data)
        // Aqui você pode fazer algo com downloadOptions, por exemplo:
        console.log("Nota fiscal gerada:", downloadOptions)

        if (downloadOptions.pdf) {
          // Redireciona para o link PDF — isso vai abrir o PDF na mesma aba
          window.open(downloadOptions.pdf, "_blank")
        } else if (downloadOptions.xml) {
          window.open(downloadOptions.xml, "_blank")
        } else if (downloadOptions.danfe) {
          window.open(downloadOptions.danfe, "_blank")
        } else {
          alert("Sem opções de download disponíveis")
        }
      } catch (e) {
        console.log("Erro ao procurar Pedido... ", e)
      }
    })

    btnComprovante.addEventListener("click", async () => {
      buscarRastreamentoIntelipost(idPedido).catch(console.error)
    })
  }
})
